/** The public widget surface. `key` is the embed's public key (`vw_pk_…`). */
export class WidgetPublicApi {
    client;
    key;
    constructor(client, key) {
        this.client = client;
        this.key = key;
    }
    headers(sessionToken) {
        return { 'x-vello-widget-key': this.key, ...(sessionToken !== undefined ? { authorization: `Bearer ${sessionToken}` } : {}) };
    }
    /** The embed's public settings (position, audiences and their topics, locale, consent text). */
    bootstrap() {
        return this.client.request({ method: 'GET', path: '/v1/widget/bootstrap', headers: this.headers() });
    }
    /** Consent (must be `true`) and start an anonymous session; the audience and topic route it in the Central. */
    startSession(input) {
        return this.client.request({ method: 'POST', path: '/v1/widget/sessions', body: input, headers: this.headers() });
    }
    /** Send one plain-text message (1..2000 characters). */
    send(sessionToken, text) {
        return this.client.request({ method: 'POST', path: '/v1/widget/messages', body: { text }, headers: this.headers(sessionToken) });
    }
    /** The visitor's own thread after a sequence (poll with the previous `nextAfter`; start with -1). */
    messages(sessionToken, after = -1) {
        return this.client.request({ method: 'GET', path: `/v1/widget/messages?after=${encodeURIComponent(String(after))}`, headers: this.headers(sessionToken) });
    }
    /** D853: the visitor picks (or changes) the city of the conversation. */
    chooseCity(sessionToken, marketId) {
        return this.client.request({ method: 'POST', path: '/v1/widget/market', body: { marketId }, headers: this.headers(sessionToken) });
    }
    /** D853: the device position as a SUGGESTION of the city (nothing is stored). */
    locateCity(latitude, longitude) {
        return this.client.request({ method: 'POST', path: '/v1/widget/market/locate', body: { latitude, longitude }, headers: this.headers() });
    }
    /** D853: a city we do not serve - counted as demand; "Avise-me" only with the explicit opt-in. */
    unservedCity(input) {
        return this.client.request({ method: 'POST', path: '/v1/widget/unserved-city', body: input, headers: this.headers() });
    }
    /** Open (or read back) the conversation's support case reference. */
    openCase(sessionToken) {
        return this.client.request({ method: 'POST', path: '/v1/widget/case', body: {}, headers: this.headers(sessionToken) });
    }
    /** End the visitor session (idempotent). */
    endSession(sessionToken) {
        return this.client.request({ method: 'DELETE', path: '/v1/widget/sessions/current', headers: this.headers(sessionToken), expect: 'empty' });
    }
}
/** The Admin's embed configuration (operator AAL2 session). */
export class WidgetAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Create an embed; the returned view already carries the key and the snippet (D429), and every later read does too. */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/config/widgets', body: input, auth: true });
    }
    list() {
        return this.client.request({ method: 'GET', path: '/v1/config/widgets', auth: true });
    }
    get(embedId) {
        return this.client.request({ method: 'GET', path: `/v1/config/widgets/${encodeURIComponent(embedId)}`, auth: true });
    }
    update(embedId, input) {
        return this.client.request({ method: 'PATCH', path: `/v1/config/widgets/${encodeURIComponent(embedId)}`, body: input, auth: true });
    }
    /** Rotate the key: the old key stops at once; the view (and every later read) carries the new key and snippet. */
    rotate(embedId) {
        return this.client.request({ method: 'POST', path: `/v1/config/widgets/${encodeURIComponent(embedId)}/rotate`, body: {}, auth: true });
    }
    /** Revoke the embed (idempotent): its key is refused from now on. */
    revoke(embedId) {
        return this.client.request({ method: 'POST', path: `/v1/config/widgets/${encodeURIComponent(embedId)}/revoke`, body: {}, auth: true });
    }
}
//# sourceMappingURL=widget.js.map